import { type FC } from "react";

import { Button } from "@snapchat/snap-design-system";

import { useApiManagementRoutes } from "../../../../core/routes/hooks";
import { Flexbox } from "../../../../shared/components";
import { DetailsBreadcrumbs } from "../../common";
import { CancelButtonCta, CreateApiTitle } from "../messages.generated";

import {
    PageTitle,
    button,
    detailsHeaderContainer,
    loadableContainer,
    stringsContainer,
} from "./CreateApiHeader.styles";

export const CreateApiHeader: FC = () => {
    const { goToApisList } = useApiManagementRoutes();

    return (
        <Flexbox justifyContent="center" className={detailsHeaderContainer}>
            <Flexbox flexDirection="column" justifyContent="center" className={stringsContainer}>
                <DetailsBreadcrumbs apiName={"Create API"} />
                <Flexbox flexDirection="row" className={loadableContainer}>
                    <PageTitle>
                        <CreateApiTitle />
                    </PageTitle>
                    <Button className={button} onClick={goToApisList}>
                        <CancelButtonCta />
                    </Button>
                </Flexbox>
            </Flexbox>
        </Flexbox>
    );
};
